/* global Plyr */

define('media',['helpers'], function (helpers) {
    'use strict';

    var media,
        videoPlyr,
        audioPlyr;

    function Media(options) {
        options = options || {};
        this.training = options.training || {};
    }

    var initAudio = function (Plyr, ID, media, dataContext, callback, returnFunc) {

        var container = document.getElementById(ID),
            parent = container.parentNode.parentNode,
            audioMaxTime = 0,
            enabledControls = [
                //'rewind', // Rewind by the seek time (default 10 seconds)
                //'fast-forward', // Fast forward by the seek time (default 10 seconds)
                //'settings', // Settings menu
                //'pip', // Picture-in-picture (currently Safari only)
                //'airplay', // Airplay (currently Safari only)
                //'play-large', // The large play button in the center
                //'fullscreen', // Toggle fullscreen

                'restart', // Restart playback
                'play', // Play/pause playback
                'progress', // The progress bar and scrubber for playback and buffering
                'current-time', // The current time of playback
                'duration', // The full duration of the media
                'mute', // Toggle mute
                'volume', // Volume control

            ];

        // Toggle captions control
        if (media.captions !== '' && media.captionsOn) {
            enabledControls.push('captions');
        }

        audioPlyr = new Plyr(container, {
            autoplay: media.autoplay,
            controls: enabledControls,
            loadSprite: false,
            captions: {active: true, update: true},
            volume: media.volume,
            keyboard: {focused: (typeof callback !== 'function'), global: false},

            listeners: {
                seek: function (e) {
                    e.preventDefault(); // required on v2
                    customSeekAudio(getTargetTime(audioPlyr, e));
                    return false    // required on v3
                }
            }
        });

        if (media.source.length) {

            audioPlyr.source = {
                type: 'audio',
                title: media.name,
                poster: media.poster,
                sources: media.source,

                tracks: media.captions === "" ? [] : [
                    {
                        kind: 'captions',
                        src: media.captions,
                        default: true
                    }
                ]
            };

        }

        var customSeekAudio = function (seekTime) {
            if (audioMaxTime > seekTime || typeof callback !== 'function') {
                audioPlyr.currentTime = seekTime;
            } else {
                audioPlyr.currentTime = audioMaxTime;
            }
        };

        var getTargetTime = function (player, input) {
            if (typeof input === "object" && (input.type === "input" || input.type === "change")) {
                return input.target.value / input.target.max * player.media.duration;
            } else {
                return Number(input);
            }
        };

        if (typeof callback === 'function') {
            audioPlyr.on('playing', function () {
                audioPlyr.on('timeupdate', function (e) {
                    if (audioMaxTime < e.detail.plyr.currentTime) audioMaxTime = e.detail.plyr.currentTime;

                    // video has ended (cannot use 'ended' event because of optional autoplay param)
                    if (Math.floor(e.detail.plyr.currentTime) === Math.floor(e.detail.plyr.duration)) {
                        if (parent) {
                            parent.removeAttribute('data-interacted');
                        }
                        callback();
                    }
                });
            });
        }

        audioPlyr.on('ready', function () {
            if (document.querySelector('.plyr--audio-title')) document.querySelector('.plyr--audio-title').parentNode.removeChild(document.querySelector('.plyr--audio-title'));
            document.querySelector('.audio-container .plyr--audio').insertAdjacentHTML('afterbegin', '<div class="plyr--audio-title">' + media.name + '</div>');

            if (media.captionsOn) audioPlyr.toggleCaptions(true);
            audioPlyr.volume = media.volume;

            if (container) {
                container.classList.remove('vh');
            }

            returnFunc('audio', audioPlyr);

        });

        // for BC
        audioPlyr.on("play", function () {
            if (typeof audioPlyr.onplay === "function") audioPlyr.onplay();
        });
        audioPlyr.on("pause", function () {
            if (typeof audioPlyr.onpause === "function") audioPlyr.onpause();
        });
        audioPlyr.on("seeked", function () {
            if (typeof audioPlyr.onseeked === "function") audioPlyr.onseeked();
        });
        //

    };

    var initVideo = function (Plyr, ID, media, box, dataContext, callback, returnFunc) {

        var container = document.getElementById(ID),
            parent = container.parentNode.parentNode,
            videoMaxTime = 0,
            enabledControls = [
                //'rewind', // Rewind by the seek time (default 10 seconds)
                //'fast-forward', // Fast forward by the seek time (default 10 seconds)
                //'settings', // Settings menu
                //'pip', // Picture-in-picture (currently Safari only)
                //'airplay', // Airplay (currently Safari only)

                'play-large', // The large play button in the center
                'restart', // Restart playback
                'play', // Play/pause playback
                'progress', // The progress bar and scrubber for playback and buffering
                'current-time', // The current time of playback
                'duration', // The full duration of the media
                'mute', // Toggle mute
                'volume', // Volume control
                'fullscreen', // Toggle fullscreen
            ];

        // Toggle captions control
        if (media.captions !== '' && media.captionsOn) {
            enabledControls.push('captions');
        }

        videoPlyr = new Plyr(container, {
            autoplay: media.autoplay,
            controls: enabledControls,
            loadSprite: false,
            captions: {active: true, update: true},
            fullscreen: {enabled: true, fallback: true, iosNative: false},
            volume: media.volume,
            ratio: '16:9',
            keyboard: {focused: (typeof callback !== 'function'), global: false},

            listeners: {
                seek: function (e) {
                    e.preventDefault(); // required on v2
                    customSeekVideo(getTargetTime(videoPlyr, e));
                    return false    // required on v3
                }
            }
        });

        if (media.source.length) {

            videoPlyr.source = {
                type: 'video',
                title: media.name,
                poster: media.poster,
                sources: media.source,
                tracks: media.captions === "" || dataContext.offlinePackage || !media.captionSupport ? [] : [
                    {
                        kind: 'captions',
                        src: media.captions,
                        default: true
                    }
                ]
            };

            if ((dataContext.offlinePackage || window.location.protocol === "file:") && document.querySelector('#video-box video') && media.captionSupport) { // add offline captions
                var captionFile = media.captions.slice(dataContext.mediaURL.length, media.captions.indexOf("?")),
                    track = document.querySelector('#video-box video').addTextTrack("subtitles", "English", "en");

                track.mode = "showing";
                var captionData = dataContext.learning.training.captions[captionFile];
                if (captionData) {
                    helpers.media.parseCaptions(captionData).map(function (cue) {
                        track.addCue(cue);
                    });
                }
                if (!window.VTTCue) track.mode = "hidden";
            }

        }

        var customSeekVideo = function (seekTime) {
            if (videoMaxTime > seekTime || typeof callback !== 'function') {
                videoPlyr.currentTime = seekTime;
            } else {
                videoPlyr.currentTime = videoMaxTime;
            }
        };

        var getTargetTime = function (player, input) {
            if (typeof input === "object" && (input.type === "input" || input.type === "change")) {
                return input.target.value / input.target.max * player.media.duration;
            } else {
                return Number(input);
            }
        };

        if (typeof callback === 'function') {
            videoPlyr.on('playing', function () {
                videoPlyr.on('timeupdate', function (e) {
                    if (videoMaxTime < e.detail.plyr.currentTime) videoMaxTime = e.detail.plyr.currentTime;

                    // video has ended (cannot use 'ended' event because of optional autoplay param)
                    if (Math.floor(e.detail.plyr.currentTime) === Math.floor(e.detail.plyr.duration)) {
                        if (parent) {
                            parent.removeAttribute('data-interacted');
                        }
                        callback();
                    }
                });
            });
        }

        videoPlyr.on('ready', function () {

            if (document.querySelector('.plyr--video-title')) document.querySelector('.plyr--video-title').parentNode.removeChild(document.querySelector('.plyr--video-title'));
            document.querySelector('.video-container .plyr__control--overlaid').insertAdjacentHTML('beforeend', '<span class="plyr--video-title">' + media.name + '</span>');

            if (media.captionsOn && media.captions !== '' && media.captionSupport) videoPlyr.toggleCaptions(true);
            videoPlyr.volume = media.volume;

            if (container) {
                container.classList.remove('vh');
            }

            returnFunc('video', videoPlyr);
        });

        videoPlyr.on("enterfullscreen", function () {
            document.body.classList.add("video-fullscreen");
        });
        videoPlyr.on("exitfullscreen", function () {
            document.body.classList.remove("video-fullscreen");
        });

        // for BC
        videoPlyr.on("play", function () {
            if (typeof videoPlyr.onplay === "function") videoPlyr.onplay();
        });
        videoPlyr.on("pause", function () {
            if (typeof videoPlyr.onpause === "function") videoPlyr.onpause();
        });
        videoPlyr.on("seeked", function () {
            if (typeof videoPlyr.onseeked === "function") videoPlyr.onseeked();
        });
        //

    };

    Media.prototype.initAudio = function (ID, media, box, dataContext, callback, returnFunc) {

        if (window.Plyr) {
            initAudio(window.Plyr, ID, media, box, dataContext, callback, returnFunc);
        } else {
            require(['Plyr'], function (Plyr) {
                window.Plyr = Plyr;
                initAudio(Plyr, ID, media, box, dataContext, callback, returnFunc);
            });
        }

    };

    Media.prototype.initVideo = function (ID, media, box, dataContext, callback, returnFunc) {

        if (media.useframe) {

            videoPlyr = document.getElementById(ID);

            var iframe = document.createElement('iframe'),
                videoSrc = media.source[0].src;

            switch (media.source[0].type) {
                case 'video/dreambroker-frame':
                    videoPlyr.classList.add('dreambroker-frame');
                    var params = (/channel\/.{8}\/.{8}/).exec(media.source[0].src.toString());
                    var src = params[0].split('/');
                    videoSrc = '//www.dreambroker.com/channel/' + src[1] + '/iframe/' + src[2];

                    break;
                case 'video/office365-frame':
                    videoPlyr.classList.add('office365-frame');
                    break;
                default:
                    break;
            }

            iframe.setAttribute('src', videoSrc);
            iframe.setAttribute('allowfullscreen', true);
            iframe.setAttribute('webkitallowfullscreen', true);
            iframe.setAttribute('mozallowfullscreen', true);
            iframe.setAttribute('frameborder', 0);

            iframe.style.width = '100%';
            iframe.style.height = '100%';

            videoPlyr.appendChild(iframe);

        } else {

            if (window.Plyr) {
                initVideo(window.Plyr, ID, media, box, dataContext, callback, returnFunc);
            } else {
                require(['Plyr'], function (Plyr) {
                    window.Plyr = Plyr;
                    initVideo(Plyr, ID, media, box, dataContext, callback, returnFunc);
                });
            }
        }
    };

    Media.prototype.parse = function (mediaArr, index, type) {

        var res = {},
            media = mediaArr[index];

        if (!media) {
            media = mediaArr[0];
        }

        res.autoplay = !!media.autoplay;

        res.captions = this.training.parseMediaURL(media.captions);

        res.captionsOn = (media.captionsOn) ? 'default' : '';

        res.captionSupport = false;

        res.name = media.name || '';

        res.poster = this.training.parseMediaURL(media.poster);
        res.poster = (res.poster) ? res.poster : '';

        res.source = [];

        res.useframe = false;

        if (type === 'video') {
            res.isVimeo = false;
            res.isYoutube = false;
            res.quality = '';
            res.provider = 'html5';

            res.source = [];

            // start BC
            if (!media.type) {
                media = helpers.component.parseProp(media, 'source', 'VideoSource')[index];
            }
            // end BC

            if (media.source && media.type) {

                if (media.type.indexOf('vimeo') > -1) {
                    res.isVimeo = true;
                    res.provider = 'vimeo';
                } else if (media.type.indexOf('youtube') > -1) {
                    res.isYoutube = true;
                    res.provider = 'youtube';
                    if (media.quality) {
                        res.quality = 'quality="' + media.quality + '"';
                    }
                }

                switch (media.type) {
                    case "video/mp4":
                        res.captionSupport = true;
                        res.source.push({src: this.training.parseMediaURL(media.source), type: media.type});
                        break;
                    case "video/dreambroker-mp4":
                        var params = (/channel\/.{8}\/.{8}/).exec(media.embededSource.toString()),
                            src = params[0].split('/'),
                            DBSource = 'https://www.dreambroker.com/channel/' + src[1] + '/' + src[2] + '/get/' + media.dbquality + '.mp4';
                        res.captionSupport = true;
                        res.source.push({
                            src: this.training.parseMediaURL(DBSource),
                            type: 'video/mp4',
                            provider: res.provider
                        });
                        break;
                    default:
                        res.useframe = !(media.type === 'video/vimeo' || media.type === 'video/youtube');
                        res.source.push({
                            src: this.training.parseMediaURL(media.embededSource !== '-' ? media.embededSource : media.source),
                            type: media.type,
                            provider: res.provider
                        });
                }
            }

        } else if (type === 'audio') {

            res.source = [];

            if (media.source) {
                res.source.push({
                    src: this.training.parseMediaURL(media.source),
                    type: 'audio/mp3'
                });
            }

        }

        res.preload = (media.preload) ? 'auto' : 'none';
        res.volume = (media.volume && media.volume >= 0 && media.volume < 1) ? media.volume : (media.volume >= 1) ? 1 : 0.5;

        return res;
    };

    return function (options) {

        if (!media) {
            media = new Media(options);
        }

        return media;
    };

});

